export default {"src":"/login-app/[GIT_HASH]/_next/static/media/id.5740c912.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};